<template>
  <div class="min-vh-100 d-flex justify-content-end text-end p-3">
    <nav class="nav nav-underline flex-column align-self-start">
      <router-link
          v-for="(link, index) in links"
          :key="index"
          :to="{ name: link.name }"
          active-class="active"
          class="nav-link"
          aria-current="page">
        {{link.title}}
      </router-link>
    </nav>
  </div>
</template>

<script setup>
 const links = [
   {name: 'projects', title: 'Проекты'},
   {name: 'servers', title: 'Сервера'},
   {name: 'tg_channels', title: 'TG чаты'},
   {name: 'api_ping', title: 'API ping'},
   {name: 'email_mailing', title: 'Email рассылка'},
   {name: 'monitor', title: 'Мониторинг'},
   {name: 'logs', title: 'Журнал'},
 ]
</script>
